import React, { useEffect, useState } from "react";
import * as S from "./index-styled";
import { generateUrl } from "@/utils/cloudinary";
import PT from "prop-types";
import { AnimatePresence } from "framer-motion";
import Hammer from "react-hammerjs";

const Slider = (props) => {
  const [loading, setLoading] = useState(false);
  const photo = generateUrl(props.slide?.photo);
  useEffect(() => {
    if (photo) {
      setLoading(true);
      const img = new Image();
      img.src = photo;
      img.onload = () => setLoading(false);
    }
  }, [photo]);
  const handleSwipe = ({ deltaX }) => {
    if (deltaX > 0) {
      props.prev();
    } else {
      props.next();
    }
  };
  return (
    <Hammer direction="DIRECTION_HORIZONTAL" onSwipe={handleSwipe}>
      <S.SliderWrap>
        <AnimatePresence exitBeforeEnter>
          <S.Slide
            initial={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            key={loading ? "loading" : photo}
            isLoading={loading}
            draggable="false"
            src={loading ? "/loaders/hearts.svg" : photo}
          />
        </AnimatePresence>
      </S.SliderWrap>
    </Hammer>
  );
};
Slider.propTypes = {
  slide: PT.object,

  next: PT.func.isRequired,
  prev: PT.func.isRequired,
};
export default Slider;
